/***
 *
 *   ROW
 *   Renders a new landing page row
 *
 *   PROPS
 *   align: left/right/center
 *   color: dark/tint/brand
 *
 **********/

import { type ReactNode } from 'react';
import { ClassHelper } from 'components/lib';
import { RowHeader } from './header.js';
import { Content } from './content.js';
import Style from './row.tailwind.js';

interface RowProps {
  align?: 'left' | 'right' | 'center' | string;
  color?: 'dark' | 'tint' | 'brand' | string;
  header?: boolean;
  customClass?: string;
  title?: string;
  desc?: string;
  mainTitle?: string;
  children?: ReactNode;
}

export function Row(props: RowProps) {
  const css = ClassHelper(Style, {
    [String(props.color)]: props.color,
    center: props.align === 'center',
    left: props.align === 'left',
  });

  if (props.header) {
    return (
      <header className={css}>
        <Content>{props.children}</Content>
      </header>
    );
  }

  return (
    <section className={`${css} ${props.customClass}`}>
      <Content>
        <RowHeader title={props.title} desc={props.desc} color={props.color} mainTitle={props.mainTitle} />

        {props.children}
      </Content>
    </section>
  );
}
